<div
  *ngIf="selectedRows && selectedRows.length > 0"
  [ngClass]="{
    'batch-container d-flex justify-content-between align-items-center': true,
    open: selectedRows.length
  }"
>
  <div class="d-flex batch-items-selected-container col">
    <div class="selected-items">
      {{ selectedRows.length }}
      {{ selectedRows.length === 1 ? 'Item' : 'Items' }} Selected
    </div>
    <div
      *ngIf="
        showSelectAll && recordCount > selectedRows.length && showSelectColumn
      "
      class="select-all"
    >
      <span (click)="onSelectAllClicked()">Select All</span>
    </div>
  </div>

  <div class="batch-actions-container col justify-content-end">
    <div
      *ngFor="let batchOption of renderableBatchOptions"
      class="batch-action-container"
      [ngClass]="
        batchOption.type === BATCH_TYPE.CUSTOM ? 'custom-batch-option' : ''
      "
      (click)="onBatchOptionClicked(batchOption)"
    >
      <ng-container [ngSwitch]="batchOption.type">
        <span *ngSwitchCase="BATCH_TYPE.DELETE">
          <span class="oi oi-trash"></span>
          <span>{{ batchOption.title }}</span>
        </span>
        <span *ngSwitchCase="BATCH_TYPE.DOWNLOAD">
          <span class="oi oi-data-transfer-download"></span>
          <span>{{ batchOption.title }}</span>
        </span>
        <span *ngSwitchCase="BATCH_TYPE.UPDATE">
          <span class="oi oi-pencil"></span>
          <span>{{ batchOption.title }}</span>
        </span>
      </ng-container>
    </div>
    <rr-table-custom-batch-options
      [batchOptionsSettings]="getCustomBatchOptions()"
      (batchOptionClicked)="onCustomBatchOptionClicked($event)"
    >
    </rr-table-custom-batch-options>
  </div>
</div>
